import React from "react";
import filterRight from "../../assets/images/svg/filterRight.svg";
import filterLeft from "../../assets/images/svg/filterLeft.svg";

const FilterButton = ({ onClick }) => {
  return (
    <div className="filter_btn_out_main cursor" onClick={onClick}>
      <img src={filterLeft} alt="filter" />
      <img src={filterRight} alt="filter" />
      <img src={filterLeft} alt="filter" />
    </div>
  );
};

export default FilterButton;
